<ion-app>
	<div class="h-full w-full flex justify-center items-center">
		<div class="flex flex-col animate-logo">
			<img
				class="w-72"
				src="assets/images/logo/racapp-white.png"
				alt="Logo image" />
			<!-- <app-loading-spinner /> -->
		</div>
	</div>
	<ion-router-outlet></ion-router-outlet>
</ion-app>
